import { render, staticRenderFns } from "./kc-pre-bottom.vue?vue&type=template&id=406e1eaa&scoped=true"
import script from "./kc-pre-bottom.vue?vue&type=script&lang=js"
export * from "./kc-pre-bottom.vue?vue&type=script&lang=js"
import style0 from "./kc-pre-bottom.vue?vue&type=style&index=0&id=406e1eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406e1eaa",
  null
  
)

export default component.exports